"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var searchTree = function searchTree(category, id) {
  var _result;
  var pureCategory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var keyChildren = "subcategories";
  if (pureCategory) {
    keyChildren = "children_data";
  }
  var result;
  var findCategory = function findCategory(category, id) {
    for (var i = 0; i < category.length; i++) {
      var _category$i, _category$i$keyChildr, _category$i2, _category$i2$keyChild;
      if (category[i].id === id) {
        result = category[i];
        break;
      }
      (_category$i = category[i]) === null || _category$i === void 0 ? void 0 : (_category$i$keyChildr = _category$i[keyChildren]) === null || _category$i$keyChildr === void 0 ? void 0 : _category$i$keyChildr.forEach(function (subcategory) {
        if (Array.isArray(subcategory)) {
          findCategory(subcategory, id);
        }
      });
      if (((_category$i2 = category[i]) === null || _category$i2 === void 0 ? void 0 : (_category$i2$keyChild = _category$i2[keyChildren]) === null || _category$i2$keyChild === void 0 ? void 0 : _category$i2$keyChild.length) > 0) {
        var _category$i3;
        findCategory((_category$i3 = category[i]) === null || _category$i3 === void 0 ? void 0 : _category$i3[keyChildren], id);
      }
    }
  };
  findCategory(Array.isArray(category) ? category : [category], id);
  return (_result = result) !== null && _result !== void 0 ? _result : [];
};
var _default = searchTree;
exports["default"] = _default;